<template>
  <div class="main_projects">
    <div class="centered">
        <div class="filters">
            <div class="right">
                <div class="filter_projects">
                    <label for="">מכרזים פעילים</label>
                    <div class="box_switch">
                        <div :class="{ selected: filters.project_attach === 'all'}" @click="filters.project_attach = 'all'" class="all">כל המכרזים</div>
                        <div :class="{ selected: filters.project_attach === 'my'}" @click="filters.project_attach = 'my'" class="my">המכרזים שלי</div>
                    </div>
                </div>
            </div>
            <div class="left">
                <div class="order_by">
                    <label>מיון לפי</label>
                    <select  name="" id="" v-model="filters.inputOrder">
                        <option value="date_end">תאריך סיום</option>
                        <option value="num_building">מס בניינים</option>
                    </select>
                </div>
                <div class="filter_by">
                    <label>סינון לפי</label>
                    <select name="" id="" v-model="filters.project_type">
                        <option value="all">כל סוגי הפרויקטים</option>
                        <option value="building_renewal">התחדשות בניינית</option>
                        <option value="urban_renewal">התחדשות מתחמית</option>
                    </select>
                </div>
            </div>
        </div>
        <ul class="projects">
            <div v-show="!items.length > 0" class="no_res">
                <div class="text_icon_container">
                    <div class="icon search_big_icon"></div>
                    <p>לא מצאנו יזמים בחיפוש שהגדרת</p>
                    <div class="btn_b text_s" @click="filters.project_attach = 'all'; filters.project_type = 'all'">איפוס</div>
                </div>
            </div>
            <ActivePrj v-for="item in items" :item="item" :key="item.token"/>
        </ul>
    </div>


  </div>
</template>


<script>
import ActivePrj from '@/components/ActivePrj.vue'

export default {
    components: { ActivePrj },
    data() {
        return {
            items: [],
            filters: {
                project_attach: 'all',
                inputOrder: 'date_end',
                project_type: 'all',
            }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.api({ action: 'projects/results',data:{ filters:this.filters }} ,(data)=>{
                this.items = data.data.items;
            });
        }
    },
    computed: {
        itemsComp() {
            // const res = [] 
            // if (this.filters.inputOrder === 'tender_end_date') {
            //     return this.items.sort((a, b) => a.tender_end_date - b.tender_end_date);
            // }
            return this.items
        },
    },
    watch: {
        filters: {
            handler: function () {
                this.init()
            },
            deep: true
        }
    }   
}
</script>

<style lang="scss" scoped>
.main_projects { background: var(--pageBG); min-height: 100vh;
    .filters {display: flex; justify-content: space-between; margin-bottom: 40px;
       
        .left {display: flex; gap: 20px;
            >div {display: flex; align-items: center; gap: 10px;
                label { color: var(--dark_blue); font-weight: 100;}
                select { font-weight: 400; border: 1px solidvar(--gray); box-shadow: var(--box-shadow); border-radius: 12px; background: #fff; color: var(--dark_blue); width: fit-content; font-size: var(--h5); outline: none; padding: 7px 7px;}
            }
        }
        .filter_projects { display: flex; align-items: center; gap: 15px;
        }
    }
    .no_res {  
        &::after { background: #fff;}
    }
    .projects { display: flex; flex-direction: column; gap: var(--gap_big);
        
    }
}
</style>